import { paramsFilter } from "@/utils/global";
import axios from "axios";
// import Api from "../api";
import vue from "../main";
import local from "./localStroage.js";
import config from "./serverUrlConfig";
import router from "../router/index.js";
// 创建一个axios实例
const instance = axios.create({
  baseURL: "",
  timeout: 300000,
});

// 给实例添加一个setToken方法，用于登录后将最新token动态添加到header，同时将token保存在localStorage中
instance.setToken = (token) => {
  instance.defaults.headers["Authorization"] = token;
  local.setItem("token", token);
};
instance.defaults.headers.post["Content-Type"] =
  "application/json; charset=utf-8";

// 设置请求拦截器，将token传入header传递给后端
instance.interceptors.request.use(
  (config) => {
    let token = JSON.parse(localStorage.getItem("token"));
    if (token) {
      config.headers["Authorization"] = token;
    }
    return config;
  },
  (error) => {
    return Promise.error(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    // console.log(response)
    if (response.data.type === "application/json") {
      let reader = new FileReader();
      reader.readAsText(response.data, "utf-8");
      reader.onload = (e) => {
        let res = JSON.parse(e.target.result);
        if (res.code != 200) {
          vue.$message.error(res.tip);
          return;
        }
      };
    } else {
      switch (response.data.code) {
        case 5005:
          vue.$alert("登陆信息已失效,请重新登陆!");
          localStorage.removeItem("token");
          router.replace("/login");
          break;
        case 1003:
          vue.$alert("登陆信息已失效,请重新登陆!");
          localStorage.removeItem("token");
          router.replace("/login");
          break;
        case 200:
          return Promise.resolve(response.data);
        default:
          if (response.data.tip) {
            vue.$message.error(response.data.tip);
            throw new Error(response.data.tip);
          } else {
            return Promise.resolve(response.data);
          }
      }
      return Promise.resolve(response.data);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

const ajax = (param, noFiltering) => {
  // 定义内部默认请求对象
  let defaultParam = {
    url: "",
    type: "get",
    params: {},
  };
  if (param.url !== "/vid/uploadStatic" && param.params && !noFiltering) {
    param.params = paramsFilter(param.params);
  }
  // 合并请求参数
  let newParams = Object.assign(defaultParam, param);
  // 设置公共请求地址、超时时间
  defaultParam.url = config.baseServerUrl + defaultParam.url;
  instance.defaults.timeout = 1000 * 30;
  // 返回一个ajax对象
  return new Promise((resolve, reject) => {
    // 处理post、get不同请求时参数处理
    let getParams, postParams;
    if (newParams.type === "get") {
      getParams = newParams.params;
    } else {
      postParams = newParams.params;
    }

    let intanceObject = {
      url: newParams.url,
      method: newParams.type,
      data: postParams,
      params: getParams,
      responseType: newParams.responseType,
      headers: param.headers,
    };
    if (newParams.onUploadProgress) {
      intanceObject.onUploadProgress = newParams.onUploadProgress;
    }
    if (newParams.timeout) {
      intanceObject.timeout = newParams.timeout;
    }
    instance(intanceObject)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export default ajax;
